import { request } from './request';

/**
 * 中心描述信息
 */
export interface DescInfo {
  footerImage: string;
  coveImage: string;
  description: string;
  key: string;
}

/**
 * 文章项目
 */
export interface ArticleItem {
  id: number;
  categoryId: number;
  title: string;
  subtitle: string;
  summary: string;
  author: string;
  coverImage: string;
  content: string;
  contentText: string;
  publishTime: string;
  attachment: string | null;
}

/**
 * 项目数量
 */
export interface ProjectNum {
  value: string;
  key: string;
}

/**
 * 中试中心信息响应
 */
export interface PilotCenterInfo {
  descInfo: DescInfo;
  articleList: ArticleItem[];
  projectNum: ProjectNum[];
}

/**
 * 获取中试中心信息
 */
export function getPilotCenterInfo() {
  return request.get('/pilot_center/info');
}
